(ns ncr.manage.datev
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [ncr.backend :as b]
   [ncr.amplitude :as amp]
   [ncr.widgets.core :as w]
   [ncr.widgets.datev :as datev]
   [ncr.etc.alert :as a]
   [ncr.etc.pf :as pf]
   [ncr.widgets.pf :as pfw]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.util :as u]
   [ncr.navigate :as n]))

(defn- start-oauth
  ([]
   (start-oauth nil))

  ([client-id]
   (go
     (u/if-ok
       [result
        (<! (b/!query
              [:datev_oauth_start
               {:clientId client-id
                :returnUrl (.-href js/window.location)}
               [:url]]))]
       (.. js/window -location (assign (:url result)))
       (js/alert (str "Error: " (pr-str result)))))))

(defn- handle-reset-status [_]
  (go
    (<! (a/!operation
          {:operation-title "Resetting DATEV Status"
           :success-title "DATEV Status Cleared"}
          (b/!mutation
            [:datev_reset_status])))
    (ps/pub! [:me/load-caps])
    (ps/pub! [::datev/reload])))

(defn- c-disconnect [{:keys [title] :as props}]
  [pf/c-button
   (w/merge-props
     {:on-click handle-reset-status :variant :danger} props) (or title "Reset Status")])

(defn- has-accounting-docs-scope? [scopes]
  (contains? (set scopes) "accounting:documents"))

(defn- c-info-entry [name value]
  [:<>
   [pf/c-text-list-item {:component :dt} name]
   [pf/c-text-list-item {:component :dd} value]])

(defn- c-user-info [userinfo]
  [:<>
   [:br]
   [c-info-entry "User Name" (:name userinfo)]
   [c-info-entry "Full Name"
    (->> [(:given_name userinfo) (:family_name userinfo)]
      (interpose " ")
      (apply str))]

   [c-info-entry "EMail" (:email userinfo)]])

(defn- c-datev-info [data]
  [:<>
   [:br]

   [c-info-entry "DATEV Connection Lifetime"
    (let [ttl (:ttl data)]
      (if (< ttl 86400)
        (str ttl " seconds")
        (str (quot ttl 86400) " days")))]

   [c-info-entry "Verbundene Anwendungen"
    [:a
     {:target :_blank
      :href "https://apps.datev.de/tokrevui"}
     [w/c-mdi-icon {:icon :open-in-new}]]]])

(defn- c-service-link [inner]
  [:a
   {:target :_blank
    :href "https://www.datev.de/web/de/datev-shop/92902-belegbilderservice/"}
   inner])

(defn c-services [services]
  [c-info-entry "Services"
   (->> services
     (sort-by :name)
     (map
       (fn [{:keys [name scopes]}]
         (let [inner [:span name]]
           (if (= scopes ["accounting:documents"])
             [c-service-link inner]
             inner))))
     (interpose ", ")
     (into [:<>]))])

(defn- client-label [client]
  (str (:name client) " " (str "(" (:consultant_number client) "/" (:client_number client) ")")))

(defn- c-blank-slate [_]
  [:<>
   [pf/c-text-content
    [pf/c-text-list {:component :dl}
     [c-info-entry "Client" "Client Is Not Connected"]
     [c-info-entry "Required Service" [c-service-link "Belegbilderservice"]]]]
   [pf/c-button
    {:class [:pf-m-primary :pf-u-mt-lg]
     :on-click #(start-oauth)}
    "Connect..."]])

#_(defn- c-document-types []
    [:<>
     (when document-types
       [:p.pf-u-mb-lg
        "Document Types: " (->> document-types (map :name) (str/join ", "))])])

(defn- c-select-client [{:keys [clients userinfo] :as data}]
  (let
    [clients
     (sort-by :label
       (for
         [{:keys [id services] :as client} clients
          {:keys [scopes]} services
          :when (has-accounting-docs-scope? scopes)]
         {:id id
          :label (client-label client)
          :services services}))

     selection
     (uix/state (first clients))]

    [:<>
     [pf/c-text-content
      [pf/c-text-list {:component :dl}
       [c-info-entry "Client"
        [pfw/c-pf-select
         {:variant :typeahead
          :label-fn client-label
          :max-height "200px"
          :width 800
          :selections
          @selection
          :on-select
          (fn [_ s _]
            (reset! selection s))}
         (sort-by :name clients)]]

       [c-services (get @selection :services)]

       (when (some? userinfo)
         [c-user-info userinfo])

       [c-datev-info data]]]

     [:<>
      [pf/c-button {:is-disabled (nil? @selection) :on-click #(start-oauth (:id @selection))} "Connect"]
      [c-disconnect {:class [:pf-u-mt-lg :pf-u-ml-lg] :title "Cancel"}]]]))

(defn- c-connected [{:keys [client userinfo] :as data}]
  [:<>
   [pf/c-text-content
    [pf/c-text-list {:component :dl}

     [:<>
      [c-info-entry "Client" [:span (client-label client)]]

      [c-info-entry "Services"
       (->> (get-in data [:client :services])
         (sort-by :name)
         (map
           (fn [{:keys [name scopes]}]
             (let [inner [:span name]]
               (if (has-accounting-docs-scope? scopes)
                 [:a
                  {:target :_blank
                   :href "https://www.datev.de/web/de/datev-shop/92902-belegbilderservice/"}
                  inner]
                 inner))))
         (interpose ", ")
         (into [:<>]))]

      (when (some? userinfo)
        [c-user-info userinfo])
      [c-datev-info data]]]]

   [c-disconnect
    {:class :pf-u-mt-lg
     :title "Disconnect"}]])

(defn- c-toolbar [{:keys [is-sandbox?]}]
  (let []
    [pf/c-toolbar
     [pf/c-toolbar-content
      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon :arrow-left
         :on-click
         (fn [_]
           (amp/navigate! {"Origin" "Manage DATEV" "Destination" "<back>"})
           (n/back!))
         :tooltip "Back"}]

       [w/c-toolbar-button
        {:icon :reload
         :on-click #(ps/pub! [::datev/reload])
         :tooltip "Reload"}]]

      (when is-sandbox?
        [pf/c-toolbar-group {:variant :icon-button-group}
         [w/c-toolbar-button
          {:icon :head-question-outline
           :on-click
           #(u/open-link! "https://wiki.suprematic.team/books/neckar/page/datev-sandbox-access")}]])]]))

(defn c-page [& [_props]]
  (let [state (datev/use-datev)]
    [:<>
     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :light
       :sticky :top
       :aria-label "Toolbar"}
      [c-toolbar {:is-sandbox? (get-in @state [1 :datev :sandbox])}]]

     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :default
       :has-overflow-scroll true
       :is-filled true
       :aria-label "DATEV"}
      [pf/c-panel {:class :ncr-u-border-bottom}
       [pf/c-panel-header {:class-name :pf-u-font-size-xl}
        "DATEV Connection"]

       [pf/c-panel-main
        [pf/c-panel-main-body {:class [:pf-u-p-md]}
         [:<>
          (match @state
            [:loading]
            [w/c-empty-progress "Loading..."]

            [:error e]
            [:<>
             [:p "Error: " (pr-str e)]
             [c-disconnect]]

            [:ok {:datev {:status status :data data}}]
            (case (keyword status)
              :NONE
              [c-blank-slate data]

              :CLIENTS
              [c-select-client data]

              :CONNECTED
              [c-connected data])
            _
            [:p "Unknown state: " (pr-str @state)])]]]]]]))
